import axios from '../../../../shared/axios/new-api-axios';

import * as actionTypes from '../constants/sms-chat';

import { validateObj } from '../../../../shared/utils';

const checkExistedChatStart = () => {
  return {
    type: actionTypes.SMS_CHAT_CHECK_EXISTED_CHAT_START,
  };
};

const checkExistedChatSuccess = (data) => {
  return {
    type: actionTypes.SMS_CHAT_CHECK_EXISTED_CHAT_SUCCESS,
    data,
  };
};

const checkExistedChatFail = (error) => {
  return {
    type: actionTypes.SMS_CHAT_CHECK_EXISTED_CHAT_FAIL,
    error,
  };
};

export const checkExistedChat = (props) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(checkExistedChatStart());

      const url = `/sms-chat/check-existed-chat`;

      axios
        .get(url, { params: validateObj(props) })
        .then((response) => {
          dispatch(checkExistedChatSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(checkExistedChatFail(err));
          reject(err);
        });
    });
  };
};
